export const getBaseUrl = () => {
    return `${window.location.protocol}//${window.location.hostname}${["80", "443", ""].includes(window.location.port) ? "" : ":" + window.location.port}/`;
}